const STAGES = new Set([
    "FLOW_STARTED", "LOGIN_DIALOG_SHOWN", "LOGIN_CONFIRMED", "LOGIN_PAGE_OPENED",
    "LOGIN_CALLBACK_RECEIVED", "SESSION_SAVED", "BIND_REQUEST_STARTED",
    "SILENT_RENEW_STARTED", "SILENT_RENEW_SUCCEEDED", "SILENT_RENEW_FAILED",
    "RELOGIN_DIALOG_SHOWN", "RELOGIN_CONFIRMED", "RELOGIN_CANCELLED",
    "POST_RENEW_QUERY_FINISHED", "FLOW_FINISHED",
]);

function createTraceId(prefix = "riot") {
    const safePrefix = String(prefix || "riot").replace(/[^A-Za-z0-9_-]/g, "").slice(0, 16) || "riot";
    return `${safePrefix}-${Date.now()}-${Math.random().toString(16).slice(2, 10)}`;
}

function normalizeTraceId(value, prefix) {
    const candidate = String(value || "").trim();
    return /^[A-Za-z0-9:_-]{1,64}$/.test(candidate) ? candidate : createTraceId(prefix);
}

function normalizeFailType(value) {
    const candidate = String(value || "").trim().toUpperCase();
    return /^[A-Z0-9_.:-]{1,64}$/.test(candidate) ? candidate : (candidate ? "UNKNOWN_ERROR" : "");
}

function reportRiotMonitorEvent(api, options = {}) {
    if (!api || typeof api.reportRiotStatsEvent !== "function" || !STAGES.has(options.stage)) return;
    const userId = Number(options.userId);
    if (!Number.isInteger(userId) || userId <= 0) return;
    const payload = {
        traceId: normalizeTraceId(options.traceId, options.scene),
        stage: options.stage,
        gamerskyUserId: userId,
        scene: options.scene === "refresh" ? "REFRESH" : "BIND",
        triggerType: String(options.triggerType || "UNKNOWN").toUpperCase(),
        occurredAtEpochMs: Number(options.occurredAtEpochMs) || Date.now(),
        elapsedMs: Number.isFinite(options.elapsedMs) && options.elapsedMs >= 0 ? options.elapsedMs : null,
        success: typeof options.success === "boolean" ? options.success : null,
        failType: normalizeFailType(options.failType),
    };
    try {
        Promise.resolve(api.reportRiotStatsEvent(payload)).catch(() => {});
    } catch (error) {
        // Monitoring is best effort and must not alter login, binding or refresh.
    }
}

function createRiotFlowMonitor(api, options = {}) {
    const traceId = normalizeTraceId(options.traceId, options.scene);
    const startedAt = Number(options.startedAt) || Date.now();
    return {
        traceId,
        record(stage, details = {}) {
            if (options.isCurrent && !options.isCurrent()) return;
            reportRiotMonitorEvent(api, {
                traceId,
                stage,
                userId: typeof options.getUserId === "function" ? options.getUserId() : options.userId,
                scene: options.scene,
                triggerType: options.triggerType,
                occurredAtEpochMs: Date.now(),
                elapsedMs: Date.now() - startedAt,
                ...details,
            });
        },
    };
}

module.exports = { createRiotFlowMonitor, createTraceId, reportRiotMonitorEvent };
